// src/campaigns/engine/campaign-engine.ts

import { CampaignDefinition, RawCampaignDefinition } from "../types/campaign.types";
import { compareCampaignPriority, dedupeCampaignsById } from "./campaign-priority.utils";
import { addDays, fromISODate, toISODate } from "./campaign-date.utils";

const DEFAULT_DAYS_BEFORE_EVENT = 7;
const DEFAULT_DAYS_AFTER_EVENT = 3;

export function resolveCampaignTimeline(campaigns: RawCampaignDefinition[]): CampaignDefinition[] {
  const enabledCampaigns = dedupeCampaignsById(campaigns)
    .filter((campaign) => campaign.enabled)
    .sort(compareCampaignPriority);

  const resolved: CampaignDefinition[] = [];
  let previousEnd: Date | null = null;

  for (const campaign of enabledCampaigns) {
    const eventDate = fromISODate(campaign.eventDate);

    const intendedStart = campaign.fixedStartDate
      ? fromISODate(campaign.fixedStartDate)
      : addDays(eventDate, -DEFAULT_DAYS_BEFORE_EVENT);

    const intendedEnd = campaign.fixedEndDate
      ? fromISODate(campaign.fixedEndDate)
      : addDays(eventDate, DEFAULT_DAYS_AFTER_EVENT);

    let startDate = intendedStart;
    let endDate = intendedEnd;

    if (previousEnd && startDate.getTime() <= previousEnd.getTime()) {
      startDate = addDays(previousEnd, 1);
    }

    if (startDate.getTime() > endDate.getTime()) {
      continue;
    }

    resolved.push({
      ...campaign,
      startDate: toISODate(startDate),
      endDate: toISODate(endDate),
    });

    previousEnd = endDate;
  }

  return resolved;
}
